import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import PageHeader from '@/components/feature/PageHeader';
import CategoriesSection from '@/pages/home/components/CategoriesSection';

export default function Spreadsheet() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <PageHeader
          titleKey="page.spreadsheet.title"
          subtitleKey="page.spreadsheet.subtitle"
          breadcrumbKey="nav.spreadsheet"
        />
        <CategoriesSection />
      </main>
      <Footer />
    </div>
  );
}